package com.milta.core.localization.translations.ro

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Istoricul traseelor",
    periodLabel = "Perioadă",
    periodLastEightDays = "Ultimele 8 zile",
    periodSingleDate = "Dată precisă",
    periodRange = "Interval de date",
    rangeFromLabel = "De la",
    rangeToLabel = "Până la",
    driverFilterLabel = "Șofer",
    driverFilterAllOption = "Toți șoferii",
    historySearchLabel = "Căutare",
    historySearchPlaceholder = "Caută șofer, destinatar, adresă, motiv…",
    columnDate = "Data",
    columnDriver = "Șofer",
    columnTotalDeliveries = "Total livrări",
    columnDelivered = "Livrate",
    columnFailed = "Nereușite",
    viewProofsAction = "Vezi dovezile",
    emptyHistoryMessage = "Nu a fost găsit niciun traseu pentru această perioadă.",
    errorInvalidPeriod = "Perioada selectată nu este validă.",
    screenBTitle = "Istoricul dovezilor de livrare",
    routeOfLabel = "Traseu din",
    totalDeliveriesLabel = "livrări",
    deliveredLabel = "livrate",
    failedLabel = "nereușite",
    backToHistoryAction = "Istoricul traseelor",
    statusDeliveredBadge = "Livrat",
    statusFailedBadge = "Nereușit",
    viewReasonAction = "Vezi motivul",
    hideReasonAction = "Ascunde motivul",
    photoPlaceholderAlt = "Nicio fotografie disponibilă",
    photoAlt = "Dovadă de livrare",
    emptyProofsMessage = "Nicio dovadă de livrare disponibilă pentru acest traseu.",
    proofsSearchLabel = "Caută livrare",
    proofsSearchPlaceholder = "Caută destinatar, adresă, motiv…",
    paginationPrevious = "Anterior",
    paginationNext = "Următor",
)
